import React from 'react';

const PaymentIcon: React.FC = () => {
  return (
    <svg
      width="73"
      height="79"
      viewBox="0 0 73 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="58.4004"
        y="4.8667"
        width="12.1667"
        height="45.0167"
        rx="3.65"
        fill="#333333"
      />
      <path
        d="M33.0869 75.1865C36.0601 77.8129 40.1174 77.882 43.125 75.4111L43.4121 75.1641C44.511 74.1776 45.7674 73.5569 47.1475 73.5527C48.4433 73.5489 49.6299 74.0892 50.6777 74.9707L50.8857 75.1514C52.2442 76.3728 53.7326 77.0693 55.4424 77.168L55.4414 77.1689C56.3981 77.2235 56.7849 77.0083 56.9512 76.8457C57.1061 76.6938 57.3055 76.3564 57.3535 75.5977L57.3643 75.2461V51.6523H59.7832C62.9734 51.6523 66.2532 51.5906 69.5029 51.6787L69.502 51.6797C70.185 51.698 70.6235 51.5894 70.9199 51.4248C71.1505 51.2968 71.3834 51.085 71.5957 50.6855V9.18652C71.554 9.08236 71.4989 8.93193 71.4688 8.75293C70.8598 5.16672 68.3573 2.50085 65.002 1.74023L64.6748 1.67285H64.6729C64.1806 1.58022 63.6956 1.4948 63.1885 1.40332H62.7402C62.4739 1.43575 61.8859 1.52734 61.4189 1.52734H61.4199C45.5608 1.5342 29.7026 1.5386 13.8428 1.52832C12.1675 1.52837 10.6104 1.74099 9.13867 2.30762L8.8457 2.42578C4.40718 4.29291 1.59088 8.45152 1.41797 13.6006L1.40918 14.1016C1.40083 34.5243 1.4043 54.9455 1.4043 75.3672L1.4082 75.8105V75.8223C1.44178 76.6446 1.91595 77.122 2.61328 77.1807L2.75586 77.1865C4.58543 77.1919 6.17295 76.5851 7.58691 75.3809L7.86719 75.1328V75.1318C8.93288 74.149 10.1834 73.5502 11.541 73.542C12.8157 73.5343 13.9976 74.0483 15.0195 74.917L15.2217 75.0957C18.1743 77.796 22.2411 77.9116 25.2939 75.4297L25.5859 75.1807C26.7011 74.1915 27.941 73.5337 29.334 73.5352C30.7256 73.5368 31.968 74.196 33.0879 75.1855L33.0869 75.1865ZM57.3945 46.7666L57.3975 11.9619C57.3979 8.37154 59.6954 5.33666 63.1475 4.4375V4.43652C63.6184 4.31358 64.149 4.29934 64.6416 4.40234L64.8506 4.4541H64.8516C67.5445 5.22456 69.0586 7.61902 69.0586 10.4609V46.7168L69.0439 47.2041C69.0356 47.3614 69.0255 47.5048 69.0205 47.6074L68.9561 48.9434H67.6191L58.7988 48.9453H57.3945V46.7666Z"
        fill="#333333"
        stroke="#C1FE40"
        stroke-width="2.80769"
      />
      <path
        d="M29.4814 19.6538C39.5536 19.6538 47.7314 27.8316 47.7314 37.9038C47.7314 47.976 39.5536 56.1538 29.4814 56.1538C19.4093 56.1538 11.2314 47.976 11.2314 37.9038C11.2314 27.8316 19.4093 19.6538 29.4814 19.6538Z"
        fill="#C2FE40"
      />
      <path
        d="M36.5149 32.6798L27.0961 42.0986L23.0068 38.0093"
        stroke="#333333"
        stroke-width="3.05622"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default PaymentIcon;
